import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaSignOutAlt } from 'react-icons/fa';
import logo from '../assets/fortunehomecare-logo.png';
import { NAV } from './navigation';
import { initials } from '../ui';

const Shell = ({ user, logout, children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const permissions = user.permissions || [];

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <div className={`app-shell${open ? ' nav-open' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src={logo} alt="Fortune Home Care" />
        </div>
        <nav className="sidebar-nav">
          {NAV.map((group) => {
            const items = group.items.filter((item) => permissions.includes(item.permission));
            if (!items.length) return null;
            return (
              <React.Fragment key={group.section}>
                <div className="nav-section">{group.section}</div>
                {items.map(({ to, label, icon: Icon }) => (
                  <NavLink key={to} to={to} end={to === '/'} className="nav-link">
                    <Icon /> {label}
                  </NavLink>
                ))}
              </React.Fragment>
            );
          })}
        </nav>
        <div className="sidebar-foot">
          <div className="avatar">{initials(user.name)}</div>
          <div className="who">
            <strong>{user.name}</strong>
            <span>{user.email}</span>
          </div>
          <button className="icon-btn" onClick={logout} title="Sign out" aria-label="Sign out">
            <FaSignOutAlt />
          </button>
        </div>
      </aside>
      <div className="scrim" onClick={() => setOpen(false)} />
      <div className="main">
        <header className="topbar">
          <button className="icon-btn" onClick={() => setOpen(true)} aria-label="Open menu">
            <FaBars />
          </button>
          <img src={logo} alt="Fortune Home Care" />
        </header>
        {children}
      </div>
    </div>
  );
};

export default Shell;
